// API base URL - empty string for dev (uses Vite proxy), full URL for production
export const API_BASE_URL = import.meta.env.VITE_API_URL || '';
// Photos CDN - empty for dev (/uploads/), CloudFront URL for production
export const PHOTOS_BASE_URL = import.meta.env.VITE_PHOTOS_URL || '/uploads';
